const URL_API = process.env.REACT_APP_API_URL;

const FUKOWebApp = {
  requestHeader: ({ token }: { token?: string }) => {
    return {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    };
  },
  url: URL_API,
};

export default {
  FUKOWebApp,
  // Add platform config
};
